import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const surveyApi = createApi({
    reducerPath: 'surveyApi',
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),

    endpoints: builder => ({

        getAllSurveys: builder.query({
            query: () => `/survey-responses/`,
        }),

    }),
});

export const {
    useGetAllSurveysQuery,
 } = surveyApi;
